<template>
  <div>
    <div>
      <v-card>
        <v-card
          flat
          class="mt-1 mb-5"
          height="100"
          width="100%"
          color="white"
          exact
        >
          <v-card-title class="ma-0">
            <v-row no-gutters class="mx-1 justify-center"
              ><span>ຍອດມູນຄ່າວັດຖຸດິບ-ນໍາເຂົ້າທັງໝົດ</span></v-row
            >
          </v-card-title>
          <v-row no-gutters class="mx-1 justify-center">
            <v-card flat color="transparent" height="30" width="96%">
              <v-row no-gutters class="justify-center">
                <p style="font-size: 2rem; color: red">
                  {{
                    totals == undefined || totals == null
                      ? 0
                      : String(parseInt(totals)).replace(
                          /(.)(?=(\d{3})+$)/g,
                          "$1,"
                        )
                  }} ກີບ
                </p></v-row
              >
            </v-card>
          </v-row>
        </v-card>
        <v-card flat class="mt-2">
          <v-card-title>
            <v-row no-gutters>
              <v-col
                cols="12"
                md="3"
                :align="$vuetify.breakpoint.width < 960 ? 'center' : 'start'"
                class="hidden-sm-and-down"
              >
                <span style="font-size: 1.2rem"
                  >ລາຍການວັດຖຸດິບ-ນໍາເຂົ້າທັງໝົດ</span
                >
                <v-divider vertical class="mx-2 hidden-sm-and-down"></v-divider>
              </v-col>
              <v-col cols="12" md="9">
                <v-row>
                 <v-text-field
              v-model="barCode"
              dense
              outlined
              class="mx-2 mt-3"
              label="ລະຫັດບາໂຄດ"
              @keyup.enter="routeBarCode"
            ></v-text-field>
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="ຄົ້ນຫາ"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mt-3 mr-2 green"
                    @click="linkAdd"
                    :width="$vuetify.breakpoint.width < 600 ? '100%' : 'auto'">
                    <v-icon color="white" large>mdi-plus</v-icon
                    ><span style="color: white; font-weight: bold"
                      >ເພີ່ມໃໝ່</span>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-card-title>
          <div v-if="loading">
            <v-data-table
              :headers="headers"
              :search="search"
              sort-by="idx"
              class="elevation-0"
              hide-default-footer
              no-data-text=""
            ></v-data-table>
            <v-row no-gutters class="justify-center pb-10">
              <SpinnerLoader :color="'#90CAF9'" :loading="true" :size="100" />
            </v-row>
          </div>
         <v-card flat v-else-if="length == false">
            <v-data-table
              :headers="headers"
              :search="search"
              sort-by="idx"
              class="elevation-0"
              hide-default-footer
              no-data-text=""
            ></v-data-table>
            <v-row class="justify-center mx-4">
              <v-card
                flat
                class=""
                color="transparent"
                style="font-size: 2rem; color: grey; margin-top: 40px"
                >ບໍ່ມີຂໍ້ມູນວັດຖຸດິບ-ນໍາເຂົ້າ
              </v-card>
            </v-row>
            <v-skeleton-loader
              style="margin-top: -125px"
              class=""
              type="image"
            >
            </v-skeleton-loader>
          </v-card>
          <v-data-table
            v-else
            large
            class="table"
            :headers="headers"
            :items="expenses"
            :search="search"
          :footer-props="{itemsPerPageText: 'ສະແດງຈໍານວນແຖວ :'}"
            fixed-header >
            <template v-slot:item="{ item }">
              <tr v-ripple="{ class: `white--text` }">
                <td>{{ item.idx }}</td>
                <td>{{ item.rawName }}</td>
                <td>
                  <span
                    >{{
                      String(item.qty).replace(/(.)(?=(\d{3})+$)/g, "$1,")
                    }}</span >
                </td>
                <td>
                  {{ String(item.price).replace(/(.)(?=(\d{3})+$)/g, "$1,") }}
                </td>
                <td>
                  {{ String(item.supplierName).replace(/(.)(?=(\d{3})+$)/g, "$1,") }}
                </td>
                <td>
                  {{ String(item.userName).replace(/(.)(?=(\d{3})+$)/g, "$1,") }}
                </td>
              <td>
                {{ item.barCodeNumber }}
              </td>
                <td>
                  {{ item.updatedAt }}
                </td>
                <td >
                  <v-row class="justify-center">
                    <v-icon
                      @click="viewExpense(item)"
                      class="mr-2"
                      color="light-blue lighten-1"
                    >
                      mdi-eye
                    </v-icon>
                  </v-row>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { SpinnerLoader } from "vue-spinners-css";
export default {
  data() {
    return {
      loading: true,
      date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu1: false,
      date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu2: false,
      deleteItem: [],
      search: "",
      headers: [
        { text: "ລໍາດັບ", value: "idx", class: "indigo white--text" },
        { text: "ຊື່ວັດຖຸດິບ", value: "rawName", class: "indigo white--text" },
        { text: "ຈໍານວນ", value: "qty", class: "indigo white--text" },
        { text: "ລາຄາ", value: "price", class: "indigo white--text" },
        { text: "ຜູ້ສະໜອງ", value: "supplierName", class: "indigo white--text" },
        { text: "ຜູ້ສັ່ງ", value: "userName", class: "indigo white--text" },
       { text: " ລະຫັດບາໂຄດ", value: "barCodeNumber", class: "indigo white--text" },
        {
          text: "ວັນທີ່ນໍາເຂົ້າ",
          value: "createdAt",
          class: "indigo white--text",
        },
        {
          text: "Actions",
          value: "actions",
      align:"center",
          sortable: false,
          class: "indigo white--text",
        },
      ],
    };
  },
  components: {
    SpinnerLoader,
  },
  computed: {
    ...mapGetters({
      expenses: "expenseMod/expenses",
      length: "expenseMod/length",
    }),
    totals() {
      var total = 0;
      if (this.expenses.length > 0) {
        for (const key in this.expenses) {
          const element = this.expenses[key];
          if (
            element.qty != null &&
            element.qty != undefined &&
            element.price != null &&
            element.price != undefined
          ) {
            total += parseFloat(element.qty) * parseFloat(element.price);
          }
        }
      }
      return total;
    },
  },
  watch: {
    length(val) {
      if (val == false) {
        this.loading = false;
      }
    },
    expenses(val) {
      if (val.length > 0) {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.getExpenses();
    this.Loading()
  },
  created() {},
  methods: {
    ...mapActions("expenseMod", ["getExpenses", "delExpense"]),
    showAlert() {
      this.$swal({
        position: "center",
        icon: "warning",
        title: `<div style='font-family:"Noto Sans Lao";' >ເຕືອນ</div>`,
        html: `<div style='font-family:"Noto Sans Lao"; font-size:1.5rem' >ທ່ານຕ້ອງການລົບອອກບໍ?</div>`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: `<div style='font-family:"Noto Sans Lao";' >ຕົກລົງ</div>`,
        cancelButtonText: `<div style='font-family:"Noto Sans Lao";' >ຍົກເລີກ</div>`,
        confirmButtonColor: "green",
        cancelButtonColor: "red",
        reverseButtons: true,
        buttonsStyling: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteExpenseConfirm();
        }
      });
    },
    showToast(icon, title) {
      this.$swal({
        icon: icon,
        title: title,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    },
    Loading() {
      if (this.length == false) {
        this.loading = false;
      }
    },
    deleteExpense(item) {
      this.deleteItem = item;
      this.showAlert();
    },
    deleteExpenseConfirm() {
      try {
        this.delExpense(this.deleteItem)
          .then((res) => {
            if (res.data.message == "SUCCESSFULLY") {
              this.showToast(
                "success",
                `<div style='font-family:"Noto Sans Lao";' >ລົບຂໍ້ມູນສໍາເລັດແລ້ວ</div>`
              );
              this.getExpenses();
            } else {
              this.showToast(
                "error",
                `<div style='font-family:"Noto Sans Lao";color:red' >ຂໍ້ມູນຜິດພາດ</div>`
              );
            }
          })
          .catch((error) => {
            this.showToast(
              "error",
              `<div style='font-family:"Noto Sans Lao";color:red' >ຂໍ້ມູນຜິດພາດ</div>`
            );
            console.log(error);
          });
      } catch (error) {
        console.log(error);
        this.showToast(
          "error",
          `<div style='font-family:"Noto Sans Lao";color:red' >ຂໍ້ມູນຜິດພາດ</div>`
        );
      }
    },
    linkAdd() {
      this.$router.push(`/staff/expense/add`);
    },
    routeBarCode() {
      if (this.barCode != null || this.barCode != undefined) {
        this.$router.push({
          path: `/staff/expense/add`,query: { barCodeNumber: this.barCode },
        });
      }
    },
    viewExpense(item) {
      this.$router.push(`/staff/expense/view/${item._id}`);
    },
  },
};
</script>
